import React, { useLayoutEffect, useRef } from 'react';
import IconButton from '@stone/ui/button/IconButton';
import ButtonPlayPause from '@stone/ui/button/ButtonPlayPause';
import customEventBus from '@common/scripts/libs/eventBus';
import classNames from 'classnames';
const ProductTilesRailNavigation = (props) => {
    const swiperRef = useRef(null);
    const helperRef = useRef(null);
    useLayoutEffect(() => {
        const uuid = props.uuid;
        const carouselinit = (data) => {
            swiperRef.current = data === null || data === void 0 ? void 0 : data.swiper;
            helperRef.current = data === null || data === void 0 ? void 0 : data.helper;
        };
        customEventBus.on(`carouselinit:${uuid}`, carouselinit);
        return () => {
            customEventBus.off(`carouselinit:${uuid}`, carouselinit);
        };
    });
    const onClick = (index) => {
        var _a;
        (_a = helperRef.current) === null || _a === void 0 ? void 0 : _a.pauseCarousel();
        setTimeout(() => {
            var _a, _b;
            index > 0 ? (_a = swiperRef.current) === null || _a === void 0 ? void 0 : _a.slideNext(500) : (_b = swiperRef.current) === null || _b === void 0 ? void 0 : _b.slidePrev(500);
        }, 100);
    };
    return (React.createElement("div", { className: classNames('rail-navigation', props.classNames) },
        props.autoplay && React.createElement(ButtonPlayPause, { initialState: 'pause', refUUID: props.uuid }),
        React.createElement("div", { className: "rail-navitation--actions" },
            React.createElement(IconButton, { onClick: () => {
                    onClick(-1);
                }, family: "10", icon: "left-chevron", type: 'button', className: `prev-${props.uuid}`, hideborder: true }),
            React.createElement(IconButton, { onClick: () => {
                    onClick(1);
                }, family: "10", icon: "right-chevron", type: 'button', className: `next-${props.uuid}`, hideborder: true }))));
};
export default ProductTilesRailNavigation;
